/**
 * Dev chrome for attribute type micro-labels on App forms.
 * Designer canvas always shows types; App shows only when REACT_APP_DEBUG=true.
 */
function parseDebugFlag(raw: string | undefined): boolean {
  if (!raw) return false
  const v = raw.trim().toLowerCase()
  return v === 'true' || v === '1' || v === 'yes'
}

/** True when App-mode forms may show attribute type chips (requires REACT_APP_DEBUG). */
export function showAppAttributeTypeLabel(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return parseDebugFlag(env.REACT_APP_DEBUG)
}
